import React, { useEffect } from "react";
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useRouteMatch,
} from "react-router-dom";
import useSetState from "../../hooks/useSetState";
import BaseLayout from "../../components/layouts/BaseLayout";
import IoTKeyDeviceList from "./IotKeyDeviceList";

const IoTKeyDevices: React.FC = () => {
  const history = useHistory();
  const tabs = [{ label: "IoT Key Devices", value: "devices" }];

  const match = useRouteMatch({
    path: "/config/iot_key_devices/:activeTabURL",
    strict: true,
    sensitive: true,
  });
  const { activeTabURL } = match?.params as any;

  const handleTabChange = (event, newValue) => {
    history.push(`/config/iot_key_devices/${newValue}`);
  };

  const [{ activeTab }, setState] = useSetState({
    activeTab: "devices",
  });

  useEffect(() => {
    setState({ activeTab: activeTabURL });
  }, [activeTabURL]);

  return (
    <BaseLayout
      title="IoT Key Devices"
      tabs={tabs}
      activeTab={activeTab}
      handleTabChange={handleTabChange}
    >
      <Switch>
        <Route path="/config/iot_key_devices/devices" exact>
          <IoTKeyDeviceList />
        </Route>
        <Redirect to="/config/iot_key_devices/devices" />
      </Switch>
    </BaseLayout>
  );
};

export default IoTKeyDevices;
